/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Preview from './irPreview';
import {
  convertPDFFromAPI,
  convertPDFURLFromAPI,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import Link from '@mui/material/Link';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';

export default function InvoicePdfSectionTwo(props) {
  const dispatch = useDispatch();
  const { fullScreenView, handleErrorMessages } = props;

  const searchInvoiceRequest = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.searchInvoiceReportRequest
  );
  const invoiceNumber = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum.data
        ?.invoiceNum || null
  );
  const invoiceDetailData = useSelector(
    (state) =>
      state?.sharedState?.InvoiceReportReducer?.invoiceDetailsByInvoiceNum?.data
  );
  const response = useSelector(
    (state) => state?.sharedState?.InvoiceReportReducer?.pdfSectionTwoPreview
  );
  const UserDefaultValues = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  localStorage.setItem('UserDefaultValues', JSON.stringify(UserDefaultValues));
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfURL] = React.useState(null);

  useEffect(() => {
    handleErrorMessages([]);
    //sectionTwoTab();
  }, [props.duplicateInvoice]);

  useEffect(() => {
    setPdfURL(null);
  }, [invoiceNumber]);

  useEffect(() => {
    if (!response || (Array.isArray(response) && response.length === 0)) {
      setPdfURL(null);
      return;
    }
    if (
      response.data instanceof ArrayBuffer &&
      response.data.byteLength === 0
    ) {
      setLoading(false);
      setPdfURL(null);
      handleErrorMessages([CONSTANTS.NO_DATA_PRINT]);
    } else if (response.data) {
      setLoading(false);
      handleErrorMessages([]);
      const lurl = convertPDFURLFromAPI(response.data);
      setPdfURL(lurl);
    }
  }, [response]);

  const onClickPrintSecTwo = async () => {
    const payload = {
      invoiceNum: [invoiceNumber],
      rebateProgramCd:
        invoiceDetailData?.rebateProgramCd ||
        searchInvoiceRequest?.rebateProgramCode,
      userId: UserDefaultValues?.userId,
      duplicate: props.duplicateInvoice,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${serviceEndPoint.INVOICE_GET_REPORT_SECTION_TWO}`,
        payload,
        {
          responseType: 'arraybuffer',
          headers: {
            Accept: 'application/octet-stream',
          },
        }
      );

      if (
        response &&
        response.data instanceof ArrayBuffer &&
        response.data.byteLength === 0
      ) {
        setLoading(false);
        handleErrorMessages([CONSTANTS.NO_DATA_PRINT]);
      } else {
        setLoading(false);
        convertPDFFromAPI(response.data);
      }
    } catch (error) {
      setLoading(false); // Stop the loading spinner
      handleErrorMessages([CONSTANTS.NO_DATA_PRINT]); // Handle error message
    }
  };

  return (
    <>
      <div className="tab-body">
        {loading && <Spinner load={loading} />}
        <div className="tab-container" bodyground="white">
          <div className="row">
            <div className="col-4 pl-0 pr-0">
              <div className="text-left">
                Display Printed Invoice [{invoiceNumber}]
              </div>
            </div>
            <div className="col-8">
              <div className="text-right font-weight-bold">
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    onClickPrintSecTwo();
                  }}
                >
                  Print this Section
                </Link>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '0px' }}>
            {!fullScreenView && <Preview pdfUrlLink={pdfUrl} />}
          </div>
        </div>
      </div>
    </>
  );
}
